@import (reference) '../../../../../constants/spacing.module.less';

.churn-win-back-banner {
  padding: @space-16;
  .banner-button {
    margin-top: @space-4;
  }
}
